import { c as _c } from "react/compiler-runtime";
import { useMediaQuery$ } from '@/hooks/useMediaQuery$';
import { type Breakpoint, breakpointUtils } from '@/lib/breakpoints';
export function useBreakpointDown$(breakpoint, t0) {
  const $ = _c(2);
  const defaultValue = t0 === undefined ? false : t0;
  let t1;
  if ($[0] !== breakpoint) {
    t1 = breakpointUtils.down(breakpoint);
    $[0] = breakpoint;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useMediaQuery$(t1, defaultValue);
}